/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StatusRouteImport } from './routes/status'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForgotPasswordResetIdRouteImport } from './routes/forgot-password-reset.$id'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeacherIndexRouteImport } from './teacher/routes/teacher.index'
import { Route as AdminIndexRouteImport } from './admin/routes/admin.index'
import { Route as TeacherSubmissionsRouteImport } from './teacher/routes/teacher.submissions'
import { Route as TeacherProfileRouteImport } from './teacher/routes/teacher.profile'
import { Route as TeacherHistoryRouteImport } from './teacher/routes/teacher.history'
import { Route as LoginTeacherRouteImport } from './teacher/routes/login.teacher'
import { Route as LoginAdminRouteImport } from './admin/routes/login.admin'
import { Route as AdminTeachersRouteImport } from './admin/routes/admin.teachers'
import { Route as AdminTopicsRouteImport } from './admin/routes/admin.topics'
import { Route as AdminPathshalasRouteImport } from './admin/routes/admin.pathshalas'
import { Route as AdminSubmissionsRouteImport } from './admin/routes/admin.submissions'
import { Route as AdminRewardRouteImport } from './admin/routes/admin.reward'
import { Route as AdminReportsRouteImport } from './admin/routes/admin.reports'
import { Route as AdminProfileRouteImport } from './admin/routes/admin.profile'
import { Route as AdminExportsRouteImport } from './admin/routes/admin.exports'
import { Route as TeacherVerifyIdRouteImport } from './teacher/routes/teacher.verify.$id'
import { Route as AdminVerifyIdRouteImport } from './admin/routes/admin.verify.$id'

const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordResetIdRoute = ForgotPasswordResetIdRouteImport.update({
  id: '/forgot-password-reset/$id',
  path: '/forgot-password-reset/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherIndexRoute = TeacherIndexRouteImport.update({
  id: '/teacher/',
  path: '/teacher/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherSubmissionsRoute = TeacherSubmissionsRouteImport.update({
  id: '/teacher/submissions',
  path: '/teacher/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherProfileRoute = TeacherProfileRouteImport.update({
  id: '/teacher/profile',
  path: '/teacher/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherHistoryRoute = TeacherHistoryRouteImport.update({
  id: '/teacher/history',
  path: '/teacher/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginTeacherRoute = LoginTeacherRouteImport.update({
  id: '/login/teacher',
  path: '/login/teacher',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginAdminRoute = LoginAdminRouteImport.update({
  id: '/login/admin',
  path: '/login/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeachersRoute = AdminTeachersRouteImport.update({
  id: '/admin/teachers',
  path: '/admin/teachers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTopicsRoute = AdminTopicsRouteImport.update({
  id: '/admin/topics',
  path: '/admin/topics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPathshalasRoute = AdminPathshalasRouteImport.update({
  id: '/admin/pathshalas',
  path: '/admin/pathshalas',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
  id: '/admin/submissions',
  path: '/admin/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRewardRoute = AdminRewardRouteImport.update({
  id: '/admin/reward',
  path: '/admin/reward',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/admin/profile',
  path: '/admin/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminExportsRoute = AdminExportsRouteImport.update({
  id: '/admin/exports',
  path: '/admin/exports',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherVerifyIdRoute = TeacherVerifyIdRouteImport.update({
  id: '/teacher/verify/$id',
  path: '/teacher/verify/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVerifyIdRoute = AdminVerifyIdRouteImport.update({
  id: '/admin/verify/$id',
  path: '/admin/verify/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/forgot-password-reset/$id': typeof ForgotPasswordResetIdRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reward': typeof AdminRewardRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin/topics': typeof AdminTopicsRoute
  '/admin/pathshalas': typeof AdminPathshalasRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
  '/admin/verify/$id': typeof AdminVerifyIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/forgot-password-reset/$id': typeof ForgotPasswordResetIdRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reward': typeof AdminRewardRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin/topics': typeof AdminTopicsRoute
  '/admin/pathshalas': typeof AdminPathshalasRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin': typeof AdminIndexRoute
  '/teacher': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
  '/admin/verify/$id': typeof AdminVerifyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/forgot-password-reset/$id': typeof ForgotPasswordResetIdRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/reward': typeof AdminRewardRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin/topics': typeof AdminTopicsRoute
  '/admin/pathshalas': typeof AdminPathshalasRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
  '/admin/verify/$id': typeof AdminVerifyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/forgot-password-reset/$id'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/reward'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/admin/topics'
    | '/admin/pathshalas'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin/'
    | '/teacher/'
    | '/teacher/verify/$id'
    | '/admin/verify/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/forgot-password-reset/$id'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/reward'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/admin/topics'
    | '/admin/pathshalas'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin'
    | '/teacher'
    | '/teacher/verify/$id'
    | '/admin/verify/$id'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/forgot-password-reset/$id'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/reward'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/admin/topics'
    | '/admin/pathshalas'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin/'
    | '/teacher/'
    | '/teacher/verify/$id'
    | '/admin/verify/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ForgotPasswordResetIdRoute: typeof ForgotPasswordResetIdRoute
  StatusRoute: typeof StatusRoute
  AdminExportsRoute: typeof AdminExportsRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminRewardRoute: typeof AdminRewardRoute
  AdminSubmissionsRoute: typeof AdminSubmissionsRoute
  AdminTeachersRoute: typeof AdminTeachersRoute
  AdminTopicsRoute: typeof AdminTopicsRoute
  AdminPathshalasRoute: typeof AdminPathshalasRoute
  LoginAdminRoute: typeof LoginAdminRoute
  LoginTeacherRoute: typeof LoginTeacherRoute
  TeacherHistoryRoute: typeof TeacherHistoryRoute
  TeacherProfileRoute: typeof TeacherProfileRoute
  TeacherSubmissionsRoute: typeof TeacherSubmissionsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  TeacherIndexRoute: typeof TeacherIndexRoute
  TeacherVerifyIdRoute: typeof TeacherVerifyIdRoute
  AdminVerifyIdRoute: typeof AdminVerifyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password-reset/$id': {
      id: '/forgot-password-reset/$id'
      path: '/forgot-password-reset/$id'
      fullPath: '/forgot-password-reset/$id'
      preLoaderRoute: typeof ForgotPasswordResetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/': {
      id: '/teacher/'
      path: '/teacher'
      fullPath: '/teacher/'
      preLoaderRoute: typeof TeacherIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/submissions': {
      id: '/teacher/submissions'
      path: '/teacher/submissions'
      fullPath: '/teacher/submissions'
      preLoaderRoute: typeof TeacherSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/profile': {
      id: '/teacher/profile'
      path: '/teacher/profile'
      fullPath: '/teacher/profile'
      preLoaderRoute: typeof TeacherProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/history': {
      id: '/teacher/history'
      path: '/teacher/history'
      fullPath: '/teacher/history'
      preLoaderRoute: typeof TeacherHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/teacher': {
      id: '/login/teacher'
      path: '/login/teacher'
      fullPath: '/login/teacher'
      preLoaderRoute: typeof LoginTeacherRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/admin': {
      id: '/login/admin'
      path: '/login/admin'
      fullPath: '/login/admin'
      preLoaderRoute: typeof LoginAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/teachers': {
      id: '/admin/teachers'
      path: '/admin/teachers'
      fullPath: '/admin/teachers'
      preLoaderRoute: typeof AdminTeachersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/topics': {
      id: '/admin/topics'
      path: '/admin/topics'
      fullPath: '/admin/topics'
      preLoaderRoute: typeof AdminTopicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pathshalas': {
      id: '/admin/pathshalas'
      path: '/admin/pathshalas'
      fullPath: '/admin/pathshalas'
      preLoaderRoute: typeof AdminPathshalasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/submissions': {
      id: '/admin/submissions'
      path: '/admin/submissions'
      fullPath: '/admin/submissions'
      preLoaderRoute: typeof AdminSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reward': {
      id: '/admin/reward'
      path: '/admin/reward'
      fullPath: '/admin/reward'
      preLoaderRoute: typeof AdminRewardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/admin/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/exports': {
      id: '/admin/exports'
      path: '/admin/exports'
      fullPath: '/admin/exports'
      preLoaderRoute: typeof AdminExportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/verify/$id': {
      id: '/teacher/verify/$id'
      path: '/teacher/verify/$id'
      fullPath: '/teacher/verify/$id'
      preLoaderRoute: typeof TeacherVerifyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/verify/$id': {
      id: '/admin/verify/$id'
      path: '/admin/verify/$id'
      fullPath: '/admin/verify/$id'
      preLoaderRoute: typeof AdminVerifyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ForgotPasswordResetIdRoute: ForgotPasswordResetIdRoute,
  StatusRoute: StatusRoute,
  AdminExportsRoute: AdminExportsRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminRewardRoute: AdminRewardRoute,
  AdminSubmissionsRoute: AdminSubmissionsRoute,
  AdminTeachersRoute: AdminTeachersRoute,
  AdminTopicsRoute: AdminTopicsRoute,
  AdminPathshalasRoute: AdminPathshalasRoute,
  LoginAdminRoute: LoginAdminRoute,
  LoginTeacherRoute: LoginTeacherRoute,
  TeacherHistoryRoute: TeacherHistoryRoute,
  TeacherProfileRoute: TeacherProfileRoute,
  TeacherSubmissionsRoute: TeacherSubmissionsRoute,
  AdminIndexRoute: AdminIndexRoute,
  TeacherIndexRoute: TeacherIndexRoute,
  TeacherVerifyIdRoute: TeacherVerifyIdRoute,
  AdminVerifyIdRoute: AdminVerifyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

